module.exports = __webpack_public_path__ + "static/img/UY@3x.85440723.jpg";